import Vue from 'vue'
import Router from 'vue-router'
import { Auth } from 'aws-amplify'

// Containers
const TheContainer = () => import('@/containers/TheContainer')
const TheContainerNoSidebar = () => import('@/containers/TheContainerNoSidebar')

// Hitachi Building POC
const Facilities = () => import('@/views/Facilities')
const FacilityInfo = () => import('@/views/FacilityInfo')
const Shops = () => import('@/views/Shops')
const ShopInfo = () => import('@/views/ShopInfo')
const ShopInfoConfirm = () => import('@/views/ShopInfoConfirm')
const Top = () => import('@/views/Top')
const Terms = () => import('@/views/Terms')
const Help = () => import('@/views/Help')
const SensorRegist = () => import('@/views/SensorRegist')
const SensorRegistInfo = () => import('@/views/SensorRegistInfo')
const SensorInfo = () => import('@/views/SensorInfo')
const SensordataDownload = () => import('@/views/SensordataDownload')
const Users = () => import('@/views/Users')
const UserInfo = () => import('@/views/UserInfo')
const Information = () => import('@/views/Information')
const InformationRegist = () => import('@/views/InformationRegist')
const PublishingSettings = () => import('@/views/PublishingSettings')
const PublishingSettingsRegist = () => import('@/views/PublishingSettingsRegist')
const PublishingSettingsUserInfo = () => import('@/views/PublishingSettingsUserInfo')
const DisplayQRcode = () => import('@/views/DisplayQRcode')
const Embed = () => import('@/views/Embed')
const EmbeddedInfo = () => import('@/views/EmbeddedInfo')
const DisplayEmbeddedCode = () => import('@/views/DisplayEmbeddedCode')
const Resellers = () => import('@/views/Resellers')
const ResellerInfo = () => import('@/views/ResellerInfo')
const SelectUserPosition = () => import('@/views/SelectUserPosition')

const EnquetedataDownload = () => import('@/views/EnquetedataDownload')

// Views - Pages
const Page404 = () => import('@/views/pages/Page404')
const Page500 = () => import('@/views/pages/Page500')
const Login = () => import('@/views/pages/Login')
const Register = () => import('@/views/pages/Register')
const Confirm = () => import('@/views/pages/Confirm')
const Rule = () => import('@/views/pages/Rule')
const ResetPassword = () => import('@/views/pages/ResetPassword')
const UpdatePassword = () => import('@/views/pages/UpdatePassword')

Vue.use(Router)

let user;

async function getUser() {
    return await Auth.currentAuthenticatedUser().then((data) => {
    if (data && data.signInUserSession) {
      return data;
    } 
  }).catch((e) => {
    console.log(e)
    return null
  });
}

const router = new Router({
  mode: 'history', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'active',
  scrollBehavior: () => ({ y: 0 }),
  routes: configRoutes()
})

function configRoutes () {
  return [
    {
      path: '/',
      redirect: '/top',
      name: 'Home',
      component: TheContainer,
      meta: { label: 'ホーム'},
      children: [
        {
          path: 'top',
          name: 'Top',
          component: Top,
          meta: { label: 'ホーム', requiresAuth: false }
        },
        {
          path: 'facilities',
          name: 'Facilities',
          component: Facilities,
          meta: { label: 'グループ情報管理', requiresAuth: true }
        },
        {
          path: 'facilityInfo/:facilityId/',
          name: 'FacilityInfo',
          component: FacilityInfo,
          meta: { label: 'グループ情報管理', requiresAuth: true }
        },
        {
          path: 'shops',
          name: 'Shops',
          component: Shops,
          meta: { label: '店舗/学校/病院情報管理', requiresAuth: true }
        },
        {
          path: 'shopInfo/:facilityId/:sectionId/',
          name: 'ShopInfo',
          component: ShopInfo,
          meta: { label: '店舗/学校/病院情報管理', requiresAuth: true }
        },
        {
          path: 'shopInfoConfirm',
          name: 'ShopInfoConfirm',
          component: ShopInfoConfirm,
          meta: { label: '店舗/学校/病院確認一覧', requiresAuth: true }
        },
        {
          path: 'sensorRegist',
          name: 'SensorRegist',
          component: SensorRegist,
          meta: { label: 'センサー管理', requiresAuth: true }
        },
        {
          path: 'sensorRegistInfo/:facilityId/:sectionId/:sensorId/',
          name: 'SensorRegistInfo',
          component: SensorRegistInfo,
          meta: { label: 'センサー管理', requiresAuth: true }
        },
        {
          path: 'sensordataDownload',
          name: 'SensordataDownload',
          component: SensordataDownload,
          meta: { label: 'センサーデータダウンロード', requiresAuth: true }
        },
        {
          path: 'terms',
          name: 'Terms',
          component: Terms,
          meta: { label: '利用規約', requiresAuth: true }
        },
        {
          path: 'help',
          name: 'Help',
          component: Help,
          meta: { label: 'マニュアル', requiresAuth: true }
        },
        {
          path: 'information/:facilityId/:sectionId/',
          name: 'Information',
          component: Information,
          meta: { label: '店舗/学校/病院情報管理 / お知らせ管理', requiresAuth: true }
        },
        {
          path: 'informationRegist/:facilityId/:sectionId/:informationId/',
          name: 'InformationRegist',
          component: InformationRegist,
          meta: { label: '店舗/学校/病院情報管理 / お知らせ管理', requiresAuth: true }
        },
        {
          path: 'enquetedataDownload/:facilityId/:sectionId/',
          name: 'EnquetedataDownload',
          component: EnquetedataDownload,
          meta: { label: '店舗/学校/病院情報管理 / アンケート結果', requiresAuth: true }
        },
        {
          path: 'publishingSettings',
          name: 'PublishingSettings',
          component: PublishingSettings,
          meta: { label: 'セキュリティ情報管理', requiresAuth: true }
        },
        {
          path: 'publishingSettingsRegist/:facilityId/:sectionId/',
          name: 'PublishingSettingsRegist',
          component: PublishingSettingsRegist,
          meta: { label: 'セキュリティ情報管理', requiresAuth: true }
        },
        {
          path: 'publishingSettingsUserInfo/:facilityId/:sectionId/',
          name: 'PublishingSettingsUserInfo',
          component: PublishingSettingsUserInfo,
          meta: { label: 'セキュリティ情報管理', requiresAuth: true }
        },
        {
          path: 'embed',
          name: 'Embed',
          component: Embed,
          meta: { label: 'グラフ埋め込み用HTML出力', requiresAuth: true }
        },
        {
          path: 'embeddedInfo/:facilityId/:sectionId/:embeddedId/',
          name: 'EmbeddedInfo',
          component: EmbeddedInfo,
          meta: { label: 'グラフ埋め込み用HTML出力', requiresAuth: true }
        },
        {
          path: 'resellers',
          name: 'Resellers',
          component: Resellers,
          meta: { label: 'リセラー情報管理', requiresAuth: true }
        },
        {
          path: 'resellerInfo/:resellerId/',
          name: 'ResellerInfo',
          component: ResellerInfo,
          meta: { label: 'リセラー情報管理', requiresAuth: true }
        },
        {
          path: 'selectUserPosition',
          name: 'SelectUserPosition',
          component: SelectUserPosition,
          meta: { label: 'リセラー選択', requiresAuth: true }
        },
        {//テイン
          path: 'users',
          name: 'Users',
          component: Users,
          meta: { label: 'ユーザー情報管理', requiresAuth: true }
        },//テイン
        {
          path: 'userInfo/:userId/',
          name: 'UserInfo',
          component: UserInfo,
          meta: { label: 'ユーザー情報管理', requiresAuth: true }
        }
      ]
    },
    {
      path: '/',
      redirect: '/top',
      name: 'Home2',
      component: TheContainerNoSidebar,
      meta: { label: 'ホーム'},
      children: [
        {
          path: 'sensorInfo/:facilityId/:sectionId/:sensorId/',
          name: 'SensorInfo',
          component: SensorInfo,
          meta: { label: 'センサー詳細', requiresAuth: true }
        },
        {
          path: 'displayQRcode/:facilityId/:sectionId/:roomId/',
          name: 'DisplayQRcode',
          component: DisplayQRcode,
          meta: { label: 'ユーザー登録用ＱＲコード', requiresAuth: true }
        },
        {
          path: 'displayEmbeddedCode/:facilityId/:sectionId/:embeddedId/',
          name: 'DisplayEmbeddedCode',
          component: DisplayEmbeddedCode,
          meta: { label: '埋め込みコード表示/プレビュー', requiresAuth: true }
        },
        ]
    },
    {
      path: '/auth',
      name: 'Authenticator',
      // 開発環境用
      // beforeEnter() {location.href = 'https://management.d.tplats.hitachi.co.jp/pages/login'},
      // ローカル開発環境
      // beforeEnter() {location.href = 'http://localhost:8080/pages/login'},
      // ステージング環境用
      // beforeEnter() {location.href = 'https://management.s.tplats.hitachi.co.jp/pages/login'},
      // cloud9開発環境用
      // beforeEnter() {location.href = 'https://0d7f4c18160c487ba24887fdfcd6df04.vfs.cloud9.ap-northeast-1.amazonaws.com/pages/login'},
      // 本番環境用
      beforeEnter() {location.href = 'https://management.tplats.hitachi.co.jp/pages/login'},
    },
    {
      path: '/pages',
      redirect: '/pages/login',
      name: 'Pages',
      component: {
        render (c) { return c('router-view') }
      },
      children: [
        {
          path: '404',
          name: 'Page404',
          component: Page404
        },
        {
          path: '500',
          name: 'Page500',
          component: Page500
        },
        {
          path: 'login',
          name: 'Login',
          component: Login
        },
        {
          path: 'register',
          name: 'Register',
          component: Register
        },
        {
          path: 'rule',
          name: 'Rule',
          component: Rule
        },
        {
          path: 'confirm',
          name: 'Confirm',
          component: Confirm
        },
        {
          path: 'resetPassword',
          name: 'ResetPassword',
          component: ResetPassword
        },
        {
          path: 'updatePassword',
          name: 'UpdatePassword',
          component: UpdatePassword
        }
      ]
    }
  ]
}

router.beforeResolve(async (to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    user = await getUser();
    if (!user) {
      return next({
        path: '/pages',
        query: {
          redirect: to.fullPath,
        }
      });
    }
    return next()
  }
  return next()
})

export default router
